var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3.6,
    fill: "#9C6923",
    rx: 1.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3.6,
    y: 7.2,
    fill: "#9C6923",
    rx: 1.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 3.6,
    y: 14.399,
    fill: "#9C6923",
    rx: 1.8
  })));
};
export default SvgMenu;